(() => {
  if (customElements.get('brvcity-results')) return;
  class Results extends HTMLElement {
    connectedCallback() {
      this._abort?.abort();
      this._abort = new AbortController();
      const signal = this._abort.signal;
      this.slides = Array.from(this.querySelectorAll('.bc-results__slide'));
      this.status = this.querySelector('[data-slide-status]');
      this.index = 0;
      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => this.select(this.index + Number(button.dataset.direction)), { signal }));
      this.addEventListener('keydown', event => {
        if (event.target.matches('input,textarea,select')) return;
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        this.select(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, { signal });
      this.querySelectorAll('.bc-results__range').forEach(range => range.addEventListener('input', () => {
        range.closest('.bc-results__comparison').style.setProperty('--br-position', range.value + '%');
      }, { signal }));
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
        if (index >= 0) this.select(index);
      }, { signal });
      this.select(0);
    }
    disconnectedCallback() { this._abort?.abort(); }
    select(index) {
      if (!this.slides.length) return;
      this.index = ((index % this.slides.length) + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      if (this.status) this.status.textContent = (this.index + 1) + ' / ' + this.slides.length;
    }
  }
  customElements.define('brvcity-results', Results);
})();
